import { Injectable, Inject } from '@angular/core';
import { ApplicationInsights, Snippet } from '@microsoft/applicationinsights-web';
import { APP_INSIGHTS_CONFIG } from './tokens';
import { OidcClientService } from '@upmc-healthplan-npm/oidc-client';

@Injectable()
export class ApplicationInsightsService {
  appInsights: ApplicationInsights;
  constructor(@Inject(APP_INSIGHTS_CONFIG) public config: Snippet['config'], private oidc: OidcClientService) {
    config.enableAutoRouteTracking = true;
    config.autoTrackPageVisitTime = true;
    config.enableAjaxPerfTracking = true;
    this.appInsights = new ApplicationInsights({
      config
    });
    this.appInsights.loadAppInsights();

    this.oidc.userObservable().subscribe(user => {
      const username = user.profile.name;
      this.appInsights.setAuthenticatedUserContext(username, null, false);
    });
  }
}
